export const CREATORS = ['uni_3221'] as const

export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  uni_3221: 'bf2042_1',
}

export const mapBF2042CreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
  }
> = {
  uni_3221: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['uni_3221']}/0.png`,
  },
}
